import { Box, Tooltip, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { orderInfoChipsStyles } from '../../../../../components/OrderInfoChips/orderInfoChipsStyles'
import { getOrders } from '../../../../../services/ApiService'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import { getComp } from '../../../../../utils/utils/DI'

function LinkToInstallationReport({
  currentServiceData,
  setInstalledOrderDealerId,
}) {
  const navigate = useNavigate()
  const classes = getStyles(orderInfoChipsStyles) // стили взаимствованы из компонента OrderInfoChips
  const statusesStore = getComp('StatusesStore')

  const [{ reportId, reportStatus }, setReportData] = React.useState({
    reportId: null,
    reportStatus: null,
  })
  const icon = statusesStore.getReportStatusImage(reportStatus)
  const name = statusesStore.getReportStatusName(reportStatus)

  useEffect(() => {
    if (currentServiceData?.installedOrderId) {
      getOrders({ orderId: currentServiceData?.installedOrderId }).then(
        (res) => {
          setReportData({
            reportId: res.content[0]?.reportId,
            reportStatus: res.content[0]?.reportStatus,
          })
          if (reportId) {
            setInstalledOrderDealerId(res.content[0]?.dealer)
          }
        },
      )
    } else if (
      reportId &&
      reportStatus &&
      !currentServiceData?.installedOrderId
    ) {
      setReportData({
        reportId: null,
        reportStatus: null,
      })
    }
  }, [currentServiceData?.installedOrderId])

  return (
    reportId && (
      <Box
        mr={2}
        sx={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}
      >
        <Tooltip title={name} placement={'top'}>
          <Box
            mx={2}
            sx={{
              ...classes.container,
              marginRight: '0px',
              background: true ? 'rgb(237 241 245)' : null,
            }}
          >
            <img
              style={{ width: '20px', height: '20px', marginBottom: '1px' }}
              alt={`report status №${reportStatus}`}
              src={icon}
            />
            <Typography
              sx={{
                ...classes.text,
                color: '#0871C3',
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  color: '#05509C',
                },
              }}
              onClick={() => navigate(`/reports/${reportId}`)}
            >
              {reportId}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    )
  )
}

export default observer(LinkToInstallationReport)
